<div class="space-y-1">
  @for (item of (menuItems$ | async) ?? []; track item.label) {
    <a
      [routerLink]="item['route']"
      class="flex items-center cursor-pointer transition-all duration-300 mx-2 rounded-lg relative group"
      [ngClass]="{
        'bg-blue-50 text-blue-600': item['active'],
        'text-gray-700 hover:bg-gray-50': !item['active'],
        'px-3 py-4 justify-center': isCollapsed(),
        'px-6 py-3': !isCollapsed(),
      }"
      [title]="isCollapsed() ? item.label : ''"
    >
      @if (item.icon) {
        <span
          class="material-icons text-2xl flex-shrink-0"
          [ngClass]="{
            'text-blue-600': item['active'],
            'text-gray-700': !item['active'],
          }"
        >
          {{ item.icon }}
        </span>
      }

      <!-- Label com transição suave -->
      <span
        class="font-medium transition-all duration-300 overflow-hidden whitespace-nowrap"
        [ngClass]="{
          'text-blue-600': item['active'],
          'text-gray-700': !item['active'],
          'w-0 opacity-0 ml-0': isCollapsed(),
          'w-auto opacity-100 ml-4': !isCollapsed(),
        }"
      >
        {{ item.label }}
      </span>

      <!-- Tooltip para menu colapsado -->
      @if (isCollapsed()) {
        <div
          class="absolute left-full ml-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 pointer-events-none"
        >
          {{ item.label }}
          <div
            class="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900"
          ></div>
        </div>
      }
    </a>
  }
</div>
